/**
 * Product card colour dots: hovering (desktop) or focusing a dot previews that colour's photo on the card.
 * Tapping a dot opens the product in that colour (it is a normal link).
 */
if (!window.__anjaCardColors && matchMedia('(hover: hover)').matches) {
  window.__anjaCardColors = true;
  /** @type {WeakMap<HTMLImageElement, {src: string, srcset: string}>} */
  const originals = new WeakMap();
  const cardImage = (dot) => /** @type {HTMLImageElement | null} */ (dot.closest('product-card, .product-card, li')?.querySelector('img'));
  const preview = (event) => {
    const dot = event.target.closest?.('.anja-dots__dot[data-img]');
    if (!dot) return;
    const img = cardImage(dot);
    if (!img) return;
    if (!originals.has(img)) originals.set(img, { src: img.src, srcset: img.srcset });
    img.srcset = '';
    img.src = dot.dataset.img;
    dot.closest('.anja-dots')?.querySelectorAll('.anja-dots__dot').forEach((d) => d.classList.toggle('is-active', d === dot));
  };
  const restore = (event) => {
    const dots = event.target.closest?.('.anja-dots');
    if (!dots || dots.contains(event.relatedTarget)) return;
    const img = cardImage(dots);
    const o = img && originals.get(img);
    if (img && o) {
      img.src = o.src;
      img.srcset = o.srcset;
    }
    dots.querySelectorAll('.anja-dots__dot').forEach((d) => d.classList.remove('is-active'));
  };
  document.addEventListener('pointerover', preview);
  document.addEventListener('focusin', preview);
  document.addEventListener('pointerout', restore);
}
